import { computed } from 'vue'
import { useAuthStore } from '/auth.js'
import { useI18n } from 'vue-i18n'


const clubEventTypes = [
  { value: 'races' },
  { value: 'camp' },
  { value: 'practice' },
  { value: 'other' },
]
const specialEventTypes = [
  { value: 'repre',       visible: s => s.isOrganizer('RCZ') },
  { value: 'scm',         visible: s => s.isOrganizer('SCM') },
  { value: 'association', visible: s => s.isManager() },
]

export function EventTypes() {
  const { t } = useI18n()
  const auth = useAuthStore()
  const isClubOrganizer = computed(() => auth.clubPermissions.includes('organizer'))

  const eventTypes = computed(() => {
    const list = []
    if (isClubOrganizer.value) list.push(...clubEventTypes)
    specialEventTypes.forEach(o => {
      if (o.visible(auth)) list.push({ title: o.title, value: o.value })
    })
    return list.map(o => ({ title: t(`enums.event_type.${o.value}`), value: o.value }))
  })

  const eventTypeRule = [ v => !!v || t('rules.required') ]

  return { eventTypes, eventTypeRule }
}
